<div class="kh-error-page-container">
    <div class="kh-error-page-logo-container">
        <img
            class="kh-error-page-logo"
            alt="KH Smarts Logo"
            src="assets/logo-color-primary.svg"
        />
    </div>
    <kh-main-header>Error 404: Page not found</kh-main-header>
</div>
